import React from 'react';
import { CountdownBanner } from './CountdownBanner';
export function PricingSection() {
  const totalPrice = 19.9;
  const totalPriceFormatted = totalPrice.toFixed(2).replace('.', ',');
  const realValue = 410;
  const discount = Math.round(100 - totalPrice / realValue * 100);
  const checkoutUrl = 'https://italia.edulabs.online/cart/43380737769590:1';
  const firePixel = () => {
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'AddToCart', {
        content_name: 'Matematica Pronta Bundle Secondaria',
        content_type: 'product',
        value: totalPrice,
        currency: 'EUR'
      });
    }
  };
  return <section id="pricing" className="w-full bg-bg-dark py-10 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-308">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.12) 0%, transparent 70%)'
    }} data-id="element-309"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.10) 0%, transparent 70%)'
    }} data-id="element-310"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-311">
        <h2 className="text-2xl sm:text-6xl font-black text-text-main text-center mb-5 sm:mb-16 tracking-tight" data-id="element-312">
          L'Offerta "Matematica Pronta"
        </h2>

        <div className="bg-bg-alt rounded-xl sm:rounded-3xl border border-cta-green/50 shadow-[0_0_50px_rgba(16,185,129,0.20)] px-4 py-5 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-313">
          <div className="absolute inset-0 rounded-xl sm:rounded-3xl border-2 border-transparent bg-gradient-to-b from-cta-green/40 to-transparent opacity-60 pointer-events-none" style={{
          maskImage: 'linear-gradient(to bottom, black, transparent)',
          WebkitMaskImage: 'linear-gradient(to bottom, black, transparent)'
        }} data-id="element-314"></div>

          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-yellow-400 text-bg-dark font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(245,158,11,0.5)] border border-white/20" data-id="element-315">
            ⭐ LA SCELTA PIÙ POPOLARE
          </div>

          <p className="text-xs sm:text-3xl font-black text-text-main text-center mt-2 sm:mt-4 mb-2 sm:mb-10 tracking-wide" data-id="element-316">
            VALORE TOTALE DEI CONTENUTI:
          </p>

          <div className="space-y-2 sm:space-y-5 mb-3 sm:mb-10 text-sm sm:text-xl" data-id="element-317">
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-318">
              <span data-id="element-319">Percorso 8 Volumi (Medie e Superiori)</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-320">
                € 197
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-321">
              <span data-id="element-322">Soluzionari & Materiale LIM</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-323">
                € 67
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-324">
              <span data-id="element-325">Manuale Recupero & Inclusion</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-326">
                € 57
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-327">
              <span data-id="element-328">6 Bonus Esclusivi</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-329">
                € 87
              </span>
            </div>

            <div className="flex justify-between text-text-main font-black pt-0 sm:pt-4 text-sm sm:text-2xl" data-id="element-330">
              <span data-id="element-331">VALORE REALE:</span>
              <span className="text-badge-red line-through" data-id="element-332">€ 410,00</span>
            </div>
          </div>

          <CountdownBanner data-id="element-333" />

          <div className="text-center mb-3 sm:mb-10 bg-gradient-to-b from-cta-green/10 to-transparent border border-cta-green/20 py-4 sm:py-10 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-334">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-cta-green to-transparent" data-id="element-335"></div>

            <div className="flex items-center justify-center gap-2 sm:gap-3 mb-2 sm:mb-4" data-id="element-336">
              <span className="text-text-sec line-through text-base sm:text-2xl font-medium" data-id="element-337">
                € 410,00
              </span>
              <span className="bg-cta-green/20 text-cta-green font-black text-[10px] sm:text-sm px-2 py-0.5 sm:px-3 sm:py-1 rounded-full" data-id="element-338">
                {discount}% OFF
              </span>
            </div>

            <p className="text-secondary text-xs sm:text-sm font-bold uppercase tracking-wider mb-2" data-id="element-339">
              Offerta Lancio
            </p>

            <div className="sm:text-8xl tracking-tighter transition-all text-[48px] font-[800] text-[#FFFFFF]" data-id="element-340">
              € {totalPriceFormatted}
            </div>

            <div className="text-text-sec text-xs sm:text-base font-medium mt-2 sm:mt-3 flex items-center justify-center gap-2" data-id="element-341">
              <span data-id="element-342">💳 Pagamento unico</span>
              <span data-id="element-343">•</span>
              <span data-id="element-344">⚡ Accesso immediato</span>
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-secondary font-bold text-[10px] sm:text-sm bg-secondary/10 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-secondary/20 animate-pulse-composited mx-auto mb-3 sm:mb-6" data-id="element-345">
            ⏰ Prezzo speciale di lancio — salirà a breve
          </span>

          <a href={checkoutUrl} onClick={firePixel} className="btn-cta btn-primary-pulse block w-full text-center text-[16px] sm:text-2xl px-4 py-4 sm:py-6 mb-3 sm:mb-6" data-id="element-346">
            <span className="relative z-10 hidden sm:inline" data-id="element-347">
              🚀 SÌ! VOGLIO IL KIT COMPLETO — € {totalPriceFormatted}
            </span>
            <span className="relative z-10 sm:hidden" data-id="element-348">
              🚀 VOGLIO IL KIT — € {totalPriceFormatted}
            </span>
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium mb-2 sm:mb-2 flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-349">
            <span data-id="element-350">⚡ Accesso Immediato</span>
            <span data-id="element-351">•</span>
            <span data-id="element-352">💳 Un solo Pagamento</span>
            <span data-id="element-353">•</span>
            <span data-id="element-354">🛡️ Garanzia 14 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}